import React, { Dispatch } from 'react';
import Modal from 'react-modal';
import CloseIcon from './svg/CloseIcon';
import { useTranslation } from 'react-i18next';
import Sparkles from './svg/Sparkles';

interface PremiumSubscriptionPromoModalProps {
    modalIsOpen: boolean;
    setModalIsOpen: Dispatch<any>
    onRequestClose?: (obj: any) => void
    onAfterOpen?: (obj: any) => void
}

export const PremiumSubscriptionPromoModal: React.FC<PremiumSubscriptionPromoModalProps> = ({ modalIsOpen, setModalIsOpen, children }) => {
    const { t } = useTranslation();

    const handleModalClose = () => {
        setModalIsOpen(false)
    }

    const handleUpgradeClick = () => {
        window.open(t('urls.upgradeAccount'))
        setModalIsOpen(false)
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterOpen={() => { }}
            onRequestClose={() => { }}
            className="react-modal premium-promo-modal"
            overlayClassName="react-modal-overlay"
            contentLabel="Plural Premium Subscription"
        >
            <div className="pull-right">
                <CloseIcon fill='#fff' onClick={handleModalClose} />
                <p className='pill'>
                    {t('bill.sidebar.PremiumPomoModal.tag')}
                </p>
            </div>
            <div className="modal-container">
                <div className="my-3 text-uppercase label-group">
                    <Sparkles width="24px" height="24px" className='mr-3' />
                    {t('bill.sidebar.PremiumPomoModal.label')}
                </div>
                <h3 className="header my-4">
                    {t('bill.sidebar.PremiumPomoModal.header')}
                </h3>
                {/* <p className="action mb-4">
                    {t('bill.sidebar.PremiumPomoModal.action')}
                </p> */}
                <div className="premium-offerings">
                    <p className="caption">{t('bill.sidebar.PremiumPomoModal.summaries.caption')}</p>
                    <p className="text">{t('bill.sidebar.PremiumPomoModal.summaries.text')}</p>
                </div>
                <div className="premium-offerings">
                    <p className="caption">{t('bill.sidebar.PremiumPomoModal.versionComparison.caption')}</p>
                    <p className="text">{t('bill.sidebar.PremiumPomoModal.versionComparison.text')}</p>
                </div>
                <div className="premium-offerings">
                    <p className="caption">{t('bill.sidebar.PremiumPomoModal.relatedBillsDetector.caption')}</p>
                    <p className="text">{t('bill.sidebar.PremiumPomoModal.relatedBillsDetector.text')}</p>
                </div>
                <div className="premium-offerings">
                    <p className="caption">{t('bill.sidebar.PremiumPomoModal.smartBillTopics.caption')}</p>
                    <p className="text">{t('bill.sidebar.PremiumPomoModal.smartBillTopics.text')}</p>
                </div>
                <div className="premium-offerings">
                    <p className="caption">{t('bill.sidebar.PremiumPomoModal.momentumIndicator.caption')}</p>
                    <p className="text">{t('bill.sidebar.PremiumPomoModal.momentumIndicator.text')}</p>
                </div>
                <button className='primary-action-btn' onClick={handleUpgradeClick}>Upgrade Now</button>
            </div>
        </Modal>
    );

}

export default PremiumSubscriptionPromoModal
